import SessionEventProto from "../session-event-proto"
import AiAgent from "../../model2/ai-agent/ai-agent"
import {EVENT_BUS_SESSION_AI_AGENTS_CHANGED} from "./@const"

export default class SessionEvent_AiAgentReset extends SessionEventProto {

    constructor(sessionEvent: any) {
        super(sessionEvent)
    }

    process() {
        const models = _.map(this.data, (record: JSONObject) => new AiAgent(record))
        gd.session.aiAgents.reset(models)
        gd.bus.triggerEvent(EVENT_BUS_SESSION_AI_AGENTS_CHANGED)
    }
}
